module.exports = __webpack_public_path__ + "static/media/portrait.a1557200.svg";